/**
 *
 *
 * @author Dylan Doldersum
 * @date 14/01/2025
 * @param {*} customerId
 * @return {*} 
 */

async function getWishlist(customerId) {
    const response = await fetch(`/admin/customers/${customerId}/metafields.json?namespace=custom&key=wishlist`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": "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", // Vervang door jouw eigen token
        },
    });
    const data = await response.json();

    if (data.metafields && data.metafields.length > 0) {
        return JSON.parse(data.metafields[0].value); // Huidige wishlist-array
    } else {
        return []; // Geen bestaande wishlist gevonden
    }
}

/**
 *
 *
 * @author Dylan Doldersum
 * @date 14/01/2025
 * @param {*} customerId
 * @param {*} wishlist
 */
async function updateWishlist(customerId, wishlist) {
    // Update het metafield met de bijgewerkte wishlist
    const response = await fetch(`/admin/api/2023-01/customers/${customerId}/metafields.json`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": "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", // Vervang door jouw eigen token
        },
        body: JSON.stringify({
            metafield: {
                namespace: "custom",
                key: "wishlist",
                value: JSON.stringify(wishlist), // De bijgewerkte wishlist-array
                value_type: "json_string",
            },
        }),
    });

    const data = await response.json();

    if (data.errors) {
        console.error("Fout bij het bijwerken van de wishlist:", data.errors);
    } else {
        console.log("Wishlist succesvol bijgewerkt:", data);
    }
}


/**
 *
 *
 * @author Dylan Doldersum
 * @date 14/01/2025
 * @param {*} customerId
 * @param {*} productId
 * @param {*} button
 */
async function toggleWishlist(customerId, productId, button) {
    const wishlist = await getWishlist(customerId); // Haal de huidige wishlist op

    if (wishlist.includes(productId)) {
        // Verwijder het product uit de wishlist
        const index = wishlist.indexOf(productId);
        if (index > -1) {
            wishlist.splice(index, 1);
        }

        // Update de knop om aan te geven dat het product niet meer in de wishlist zit
        button.classList.remove('in-wishlist');
        showToast('Product verwijderd uit je wishlist!', 'success');
    } else {
        // Voeg het product toe aan de wishlist
        wishlist.push(productId);

        // Update de knop om aan te geven dat het product in de wishlist zit
        button.classList.add('in-wishlist');
        showToast('Product succesvol toegevoegd aan je wishlist!', 'success');
    }

    // Werk de wishlist bij in de metafield
    await updateWishlist(customerId, wishlist);
}

document.querySelectorAll('.product-card__wishlist').forEach(button => {
    button.addEventListener('click', () => {
        const productId = button.getAttribute('data-product-handle');

        if (!window.customerId) {
            showToast('Je moet ingelogd zijn om een product toe te voegen aan je wishlist.', 'error');
            return;
        }

        toggleWishlist(window.customerId, productId, button).catch(error => {
            console.error("Fout bij het bijwerken van de wishlist:", error);
            showToast('Er is iets misgegaan. Probeer het opnieuw.', 'error');
        });
    });
});
